import { type LocationResult } from 'app/services/chatBot';
import { logError } from 'app/services/logger';
import { format, parseJSON } from 'date-fns';

export const formatLocationBusinessHours = (location: LocationResult): string | null => {
  try {
    const formattedOpenTime = format(parseJSON(location?.full_hours?.utc_open_time), 'h:mm a');
    const formattedCloseTime = format(parseJSON(location?.full_hours?.utc_close_time), 'h:mm a');

    return `${formattedOpenTime} - ${formattedCloseTime}`;
  } catch (error) {
    logError('Could not properly format business hours for the given location:', location);
    return null;
  }
};

export const isLocationBrandEducated = (location: LocationResult) => !!location.tags.length;
